module.exports = __webpack_public_path__ + "img/service_img17.40a694fc.png";